import { useState, useEffect } from 'react';
// material
import { Container, Typography, Card, Tab, Box, Stack } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import 'react-toastify/dist/ReactToastify.css';


// components
import Page from '../components/Page';
import Pending from '../components/kycLists/Pending';
import InProgress from '../components/kycLists/InProgress';
import Completed from '../components/kycLists/Completed';
import Rejected from '../components/kycLists/Rejected';
import NotCompleted from '../components/kycLists/NotCompleted';

export default function Kycs() {
  const [value, setValue] = useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Page title="KYC">
        <Container maxWidth="xl">
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h4" gutterBottom>
              KYCs
            </Typography>
            {/* <Button variant="contained">New Kyc</Button> */}
          </Stack>
          <Card>
            <Box sx={{ width: '100%', marginTop: '20px' }}>
              <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <TabList onChange={handleChange}>
                    <Tab label="Mandatory KYC" value="1" />
                    <Tab label="Under Verification" value="2" />
                    <Tab label="Completed" value="3" />
                    <Tab label="Rejected" value="4" />
                    <Tab label="Pending" value="5" />
                  </TabList>
                </Box>
                <TabPanel value="5">
                  <Pending />
                </TabPanel>
                <TabPanel value="2">
                  <InProgress />
                </TabPanel>
                <TabPanel value="3">
                  <Completed />
                </TabPanel>
                <TabPanel value="4">
                  <Rejected />
                </TabPanel>
                <TabPanel value="1">
                  <NotCompleted />
                </TabPanel>
              </TabContext>
            </Box>
          </Card>
        </Container>
      </Page>
    </>
  );
}
                                                                                           
                        
                                                                                                                                                                                                                                            
                                                        